export default __webpack_public_path__ + "24d91c49ff07cb699fc45cc29257789a.svg";